import { CurrencyDollarCircle, ShieldTick } from "@untitledui/icons"
import type { ApiEstimate } from "@/lib/api/types"
import type { PublicShopProfile } from "@/lib/api/public-consumer"

// The ONLY place a price appears in the whole consumer journey — and only once
// the shop has actually completed (and therefore stands behind) the number.
// Before that, we set the honest expectation instead of showing an AI guess.
export function FinalCostCard({
  estimate,
  shop,
}: {
  estimate: ApiEstimate
  shop: PublicShopProfile
}) {
  const finalized = estimate.status === "Completed" && (estimate.avg ?? 0) > 0

  if (!finalized) {
    return (
      <div className="flex items-start gap-3 rounded-2xl border border-zinc-200/70 bg-white px-4 py-4">
        <div className="grid size-9 shrink-0 place-items-center rounded-xl bg-zinc-100 text-zinc-400">
          <CurrencyDollarCircle className="size-5" aria-hidden />
        </div>
        <div className="min-w-0">
          <p className="text-[13.5px] font-semibold leading-tight text-zinc-900">
            Final cost
          </p>
          <p className="mt-0.5 text-[14px] leading-snug text-zinc-600">
            {shop.name} will share your exact price here once they’ve looked over
            your car. No surprises.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50/70 to-white px-5 py-5">
      <p className="text-[13px] font-semibold text-emerald-800">
        Final cost
      </p>
      <p className="mt-1 text-[34px] font-bold leading-none tracking-tight text-zinc-900">
        ${Math.round(estimate.avg).toLocaleString()}
      </p>
      <p className="mt-2 flex items-center gap-1.5 text-[13px] font-medium text-emerald-800">
        <ShieldTick className="size-3.5" aria-hidden />
        Confirmed by {shop.name}
      </p>
    </div>
  )
}
